export default __webpack_public_path__ + "assets/images/9ec4f31b404ed8e5188c576ee0a74b27.png";